<template>
  <div>
    <a-card>
      <template slot="title">
        <toolbar-header
          title="Master Barang"
          :loading-refresh="loadingRefresh"
          @create="showModal('create', {})"
          @refresh="getAllData(true)"
          @export-excel="exportExcel"
          @export-pdf="exportPdf"
        />
      </template>
      <a-table :columns="columns" :dataSource="data" :pagination="{
        hideOnSinglePage: true,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total) => `Total ${total} items`,
        pageSizeOptions: ['10', '20', '30'],
      }" size="small" style="margin: -25px;">
        <div slot="filterDropdown" slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }" style="padding: 8px;">
          <a-input v-ant-ref="(c) => (searchInput = c)" :placeholder="`Search ${column.title}`" :value="selectedKeys[0]"
            style="width: 188px; margin-bottom: 8px; display: block;" @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              " @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)
                " />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)
            ">
            Search
          </a-button>
          <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>
        <a-icon slot="filterIcon" slot-scope="filtered" type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }"></a-icon>
        <template slot="customRender" slot-scope="text, record, index, column">
          <span v-if="searchText && searchedColumn === column.dataIndex">
            <template v-for="(fragment, i) in text
              .toString()
              .split(
                new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
              )">
              <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i" class="highlight">{{ fragment
                }}</mark>
              <template v-else>{{ fragment }}</template>
            </template>
          </span>
          <template v-else>
            {{ text }}
          </template>
        </template>
        <a slot="name" slot-scope="text" href="javascript:;">{{ text }}</a>
        <span slot="customTitle"><a-icon type="smile-o" /> Kode</span>
        <!-- <span slot="reorder" slot-scope="text">
            <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? 'Reorder' : 'Tidak' }}</a-tag>
          </span> -->
        <span slot="action" slot-scope="text, record">
          <a href="javascript:void(0)" class="text-warning" @click="showModal('update', record)">
            <a-icon type="edit"></a-icon>
          </a>
          <a-divider type="vertical" />
          <a href="javascript:void(0)" class="text-danger" @click="showDeleteConfirm(record)">
            <a-icon type="delete"></a-icon>
          </a>
          <!-- <a href="javascript:;" class="ant-dropdown-link">
              More actions <a-icon type="down" />
            </a> -->
        </span>
        <span slot="harga" slot-scope="text">
          {{ formatCurrency(text) }}
        </span>
        <span slot="tgl" slot-scope="text">
          {{ formatDate(text) }}
        </span>
        <span slot="Grosir" slot-scope="text">
          {{ text.length }} Harga Grosir
        </span>
        <template slot="expandedRowRender" slot-scope="record">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <a-table :columns="columnChildren" :dataSource="record.harga_grosir" size="small" :pagination="{
                hideOnSinglePage: true,
                defaultPageSize: 10,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} items`,
                pageSizeOptions: ['10', '20', '30'],
              }">
                <span slot="formatCurrency" slot-scope="text">
                  {{ formatCurrency(text) }}
                </span>
              </a-table>
            </div>
          </div>
        </template>
      </a-table>
    </a-card>
    <a-modal v-model="formvisible" title="Form Barang" :dialogStyle="{ top: '10px' }">
      <template slot="footer">
        <a-button class="btn btn-outline-danger" @click="handleCancel">Cancel</a-button>
        <a-button class="btn btn-outline-primary" @click="handleSubmit">Submit</a-button>
      </template>
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-1">
          <label class="">Nama</label>
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
          <a-input class="" v-model="modalInput.nama" placeholder="Masukan Nama"></a-input>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
          <label class="">Kode</label>
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 mt-1">
          <a-input class="" v-model="modalInput.kode" placeholder="Masukan Kode"></a-input>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
          <label class="">Satuan</label>
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 mt-1">
          <a-input class="" v-model="modalInput.satuan" placeholder="Masukan Satuan"></a-input>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
          <label class="">Harga Beli</label>
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 mt-1">
          <cleave ref="harga" :options="{ numeral: true }" class="ant-input" :raw="true"
            style="text-align: right; width: 200px" v-model="modalInput.harga_beli" placeholder="Masukan Harga Beli" />
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
          <label class="">Harga Jual</label>
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 mt-1">
          <cleave ref="harga" :options="{ numeral: true }" class="ant-input" :raw="true"
            style="text-align: right; width: 200px" v-model="modalInput.harga_jual" placeholder="Masukan Harga Jual" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-2">
          <label class="">Harga Grosir</label>
          <a-button @click="addTier" class="btn btn-outline-success ml-3">+ Tambah Harga Grosir</a-button>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-1">
          <div class="pricing-tier">
            <div v-for="(tier, index) in modalInput.harga_grosir" :key="index" class="tier-row">
              <div class="form-group">
                <label for="minQuantity" v-if="index === 0">Jumlah Min.</label>
                <div class="input-group">
                  <cleave ref="price" :options="{ numeral: true }" class="ant-input" :raw="true"
                    style="text-align: right; width: 80px" v-model="tier.min_qty" placeholder="≥" min="1" />
                </div>
              </div>
              <div class="form-group">
                <label for="price" v-if="index === 0">Harga Grosir</label>
                <div class="input-group">
                  <cleave ref="price" :options="{ numeral: true }" class="ant-input" :raw="true"
                    style="text-align: right; width: 200px" v-model="tier.harga" placeholder="Harga" min="0" />
                </div>
              </div>
              <a-button @click="removeTier(index)" class="btn btn-outline-danger">Hapus</a-button>
            </div>
          </div>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
          <label class="">Re-Order</label>
        </div>
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 mt-1">
          <cleave ref="reorder" :options="{ numeral: true }" class="ant-input" :raw="true"
            style="text-align: right; width: 200px" v-model="modalInput.reorder" placeholder="Masukan Re-Order" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
/* Import Script */
import { Modal } from 'ant-design-vue'
import * as lou from '@/services/data/lou'
import moment from 'moment'
import Cleave from 'vue-cleave-component'
import ToolbarHeader from '@/components/ToolbarHeader.vue'
import { exportExcelHelper } from '@/utils/exportData'
// import { mapState } from 'vuex'
/* End Script Import Script */

/* Kolom atau header dari table */
const columns = [
  {
    title: 'Action',
    scopedSlots: { customRender: 'action' },
    width: 70,
  },
  // {
  //   title: 'Harga Grosir',
  //   dataIndex: 'harga_grosir',
  //   width: 100,
  //   align: 'right',
  //   scopedSlots: {
  //     customRender: 'Grosir',
  //   },
  //   sorter: (a, b) => a.length - b.length,
  // },
  {
    title: 'Kode',
    dataIndex: 'kode',
    width: 100,
    // fixed: 'left',
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'customRender',
    },
    onFilter: (value, record) =>
      record.kode.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus()
        }, 0)
      }
    },
  },
  {
    title: 'Nama',
    dataIndex: 'nama',
    width: 100,
    // fixed: 'left',
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'customRender',
    },
    onFilter: (value, record) =>
      record.nama.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus()
        }, 0)
      }
    },
  },
  {
    title: 'Satuan',
    dataIndex: 'satuan',
    width: 100,
    // fixed: 'left',
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'customRender',
    },
    onFilter: (value, record) =>
      record.satuan.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => {
          this.searchInput.focus()
        }, 0)
      }
    },
  },
  {
    title: 'Harga Beli',
    dataIndex: 'harga_beli',
    width: 100,
    align: 'right',
    scopedSlots: {
      customRender: 'harga',
    },
    sorter: (a, b) => a.harga_beli - b.harga_beli,
  },
  {
    title: 'Harga Jual',
    dataIndex: 'harga_jual',
    width: 100,
    align: 'right',
    scopedSlots: {
      customRender: 'harga',
    },
    sorter: (a, b) => a.harga_jual - b.harga_jual,
  },
  {
    title: 'Re-Order',
    dataIndex: 'reorder',
    width: 100,
    // fixed: 'left',
    sorter: (a, b) => a.reorder - b.reorder,
    scopedSlots: {
      customRender: 'reorder',
    },
  },
]
/* End script Kolom atau header dari table */

/* Data dari table */
const data = []
/* End script Data dari table */

export default {
  components: {
    cleave: Cleave,
    ToolbarHeader,
  },
  computed: {
    // ...mapState(['settings', 'user']),
  },
  created() {
    this.getAllData()
  },
  /* Data variable vue */
  data() {
    return {
      loadingRefresh: false,
      searchText: '',
      tgl1: '',
      tgl2: '',
      searchInput: null,
      searchedColumn: '',
      name: 'Tabletabungan',
      visible: false,
      allMaster: [],
      masterDataSupplier: [],
      masterDataKategori: [],
      data,
      columns,
      columnChildren: [
        {
          title: 'Jumlah Minimal',
          dataIndex: 'min_qty',
          ellipsis: true,
          align: 'right',
          scopedSlots: {
            customRender: 'formatCurrency',
          },
          sorter: (a, b) => a.min_qty - b.min_qty,
        },
        {
          title: 'Harga',
          dataIndex: 'harga',
          ellipsis: true,
          align: 'right',
          scopedSlots: {
            customRender: 'formatCurrency',
          },
          sorter: (a, b) => a.harga - b.harga,
        },
      ],
      datenow: '',
      componentKey: 0,

      // Modal property
      action: null,
      formvisible: false,
      editdata: {},
      modalInput: {
        nama: '',
        kode: '',
        satuan: '',
        harga_beli: 0,
        harga_jual: 0,
        harga_grosir: [],
        reorder: 0,
      },
      tiers: [
        { minQuantity: 3, price: 120000 }, // Sample data, you can change this
        { minQuantity: 5, price: 110000 }, // Sample data, you can change this
      ],
    }
  },
  /* End Data variable vue */
  mounted: function () {
    const date = moment().format('YYYY-MM-DD') // Tanggal hari ini format 2020-12-21
    // localStorage.removeItem('newkoperasiedittabungandata')
    this.tgl1 = date
    this.tgl2 = date
    this.datenow = date.toString()
    this.getAllData()
    // this.getDataMaster()
  },
  methods: {
    moment,
    addTier() {
      // console.log('this.modalInput.harga_grosir', this.modalInput.harga_grosir)
      this.modalInput.harga_grosir.push({ min_qty: null, harga: null })
    },
    removeTier(index) {
      this.modalInput.harga_grosir.splice(index, 1)
    },
    async exportPdf() {
      // this.amodal.selectedIndex = i
      var res = await lou.ngetDocumentPdf('retail/master/barang?preview=pdf', false, false)
      if (res) {
        // console.log("Success", response);
        const blob = new Blob([res], {
          type: 'application/pdf',
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.target = '_blank'
        // link.download = filename
        link.click()
        // const objectUrl = URL.createObjectURL(blob)
        // console.log('objectUrl', objectUrl)
        // this.amodal.ArrayBuffer = objectUrl
        URL.revokeObjectURL(blob)
        setTimeout(() => {
          this.componentKey += 1
          // this.amodalvisible = true
        }, 500)
      }
      // console.log('record.url2_invoice', record.url2_invoice)
      // window.open(record.url2_invoice, '_blank').focus()
    },
    showModal(action, data) {
      // this.getDataMaster()
      this.formvisible = true
      this.action = action
      if (action === 'update') {
        this.modalInput = this.$g.clone(data)
        this.editdata = data
      } else {
        this.action = 'create'
        this.modalInput = {
          nama: '',
          kode: '',
          satuan: '',
          harga_beli: 0,
          harga_jual: 0,
          harga_grosir: [],
          reorder: 0,
        }
        this.editdata = {}
      }
    },
    async getDataMaster() {
      var resmasterDataSupplier = await lou.customUrlGet2('master/supplier')
      var resmasterDataKategori = await lou.customUrlGet2('master/kategori_bahan')
      if (resmasterDataSupplier !== null) {
        this.masterDataSupplier = []
        resmasterDataSupplier.data.forEach(element => {
          var ret = {
            ...element,
            label: element.nama_perusahaan + ' - ' + element.nama_kontak,
          }
          this.masterDataSupplier.push(ret)
        })
      } else {
        lou.shownotif('Error!', 'Master Data Supplier failed to fetch from API.', 'error')
      }
      if (resmasterDataKategori !== null) {
        this.masterDataKategori = resmasterDataKategori.data
      } else {
        lou.shownotif('Error!', 'Master Data Kategori failed to fetch from API.', 'error')
      }
    },
    async getAllData(onclick = false) {
      this.loadingRefresh = true
      var response = await lou.customUrlGet2('retail/master/barang')
      if (response) {
        this.data = response.data
        if (onclick) {
          lou.shownotif('Refresh', 'Data telah di refresh.')
        }
        setTimeout(() => {
          this.loadingRefresh = false
        }, 450)
      } else {
        setTimeout(() => {
          this.loadingRefresh = false
        }, 450)
      }
      // console.log('this.data', this.data)
    },
    formatDate(value) {
      return moment(value).format('DD-MM-YYYY')
    },
    showDeleteConfirm(deldata) {
      Modal.confirm({
        title: 'Are you sure delete this data?',
        content: "You can't prevent this!!! ",
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: async () => {
          var response = await lou.customUrlDelete2('retail/master/barang/' + deldata.id)
          if (response) {
            this.getAllData()
          }
        },
        onCancel: () => {
          // console.log('Cancel')
        },
      })
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },

    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },

    // Modal function
    async handleSubmit() {
      var fd = this.$g.clone(this.modalInput)
      var res = false
      if (this.action === 'update') {
        res = await lou.customUrlPut2('retail/master/barang', fd)
      } else {
        res = await lou.customUrlPost2('retail/master/barang', fd)
      }
      if (res) {
        this.getAllData()
        this.handleCancel()
      }
    },
    handleCancel() {
      this.formvisible = false
      this.action = 'create'
      this.modalInput = {
        nama: '',
        kode: '',
        satuan: '',
        harga_beli: 0,
        harga_jual: 0,
        harga_grosir: [],
        reorder: 0,
      }
      this.editdata = {}
    },
    async exportExcel() {
      await exportExcelHelper(this.columns, this.data, 'Data Master Barang.xlsx')
    },
    formatCurrency(v) {
      return lou.curency(v)
    },
  },
}
</script>

<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.pricing-tier {
  padding: 20px;
}

.tier-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.form-group {
  margin-right: 15px;
  width: 200px;
}

.input-group-text {
  width: 50px;
}
</style>
